import React from 'react';
import classNames from 'classnames';
import styles from './ServiceAuthModalDecorations.module.css';

const ServiceAuthModalDecorations = () => {
  return (
    <div className={styles.container}>
      <div className={classNames(styles.big_block)}>
        <div className={styles.big_block_background}></div>
        <div className={styles.big_block_logo}></div>

        <h2 className={styles.big_block_title}>
          <span className={styles.big_block_fancy_text}></span>2 млн ответов
        </h2>
        <h3 className={styles.big_block_subtitle}>на вопросы по школьной программе</h3>
      </div>

      <div className={classNames(styles.small_blocks)}>
        <div className={classNames(styles.small_block, styles.block)}></div>
        <div className={classNames(styles.small_block, styles.block)}></div>
        <div className={classNames(styles.small_block, styles.block)}></div>
      </div>
    </div>
  );
};

export default ServiceAuthModalDecorations;
